export default __webpack_public_path__ + "static/media/02bg.f787cb96.png";